/**
 * next/link shim: a plain anchor whose plain-clicks navigate client-side
 * through the history router (zero network — the SPA is the bundle). Native
 * semantics (middle-click, cmd-click, copy link) preserved.
 */
import { forwardRef, type AnchorHTMLAttributes, type ReactNode } from "react";
import { navigate } from "../router";

type Props = AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string;
  prefetch?: boolean;
  children?: ReactNode;
};

const Link = forwardRef<HTMLAnchorElement, Props>(function Link({ href, prefetch: _p, onClick, children, ...rest }, ref) {
  return (
    <a
      ref={ref}
      href={href}
      onClick={(e) => {
        onClick?.(e);
        if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        if (rest.target && rest.target !== "_self") return;
        e.preventDefault();
        navigate(href);
      }}
      {...rest}
    >
      {children}
    </a>
  );
});
export default Link;
